import { TEXTS } from '../../constants';
import {
  SectionWrapper,
  ContentContainer,
  SectionHeading,
  SectionSubtext,
  BioCard,
  BioText,
} from './styles';

const BiographySection = ({ fullBio, firstName, fullName }) => {
  if (!fullBio) return null;

  const displayName = firstName || fullName.split(' ')[0];

  // Bio comes from a single-line GHL field with no real line breaks.
  // Paragraphs are separated by "||" (also support real blank lines).
  const paragraphs = String(fullBio)
    .split(/\s*\|\|\s*|\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <SectionWrapper>
      <ContentContainer>
        <SectionHeading>{TEXTS.biography.getTitle(displayName)}</SectionHeading>
        <SectionSubtext>{TEXTS.biography.subtitle}</SectionSubtext>
        <BioCard>
          {paragraphs.map((paragraph, index) => (
            <BioText
              key={index}
              sx={{ mb: index < paragraphs.length - 1 ? 2 : 0 }}
            >
              {paragraph}
            </BioText>
          ))}
        </BioCard>
      </ContentContainer>
    </SectionWrapper>
  );
};

export default BiographySection;
